import React from 'react';

import ButtonDropdown from 'components/ButtonDropdown';
import PaginatorComponent from 'components/Paginator';

import './styles.css';

const Actions = ({
  exportBookingsCsvInBackground,
  exportBookingsWithoutFinancialDataCsvInBackground,
  exportContactsCsvInBackground,
  exportingBookingsCsv,
  exportingContactsCsv,
  disableExporting
}) => (
  <ButtonDropdown
    small
    title="Export Options"
    className="exportOptionsButton"
    menuPosition={ButtonDropdown.MENU_POSITION_TOP_RIGHT}
    isLoading={exportingBookingsCsv || exportingContactsCsv}
    disabled={disableExporting}
    tooltip={disableExporting && 'No bookings to export'}>
    <ButtonDropdown.Option
      className="backgroundExportButton"
      onClick={exportContactsCsvInBackground}
      disabled={exportingContactsCsv}>
      Background contacts CSV export
    </ButtonDropdown.Option>
    <ButtonDropdown.Option
      className="backgroundExportButton"
      onClick={exportBookingsWithoutFinancialDataCsvInBackground}
      disabled={exportingBookingsCsv}>
      Background bookings CSV export
    </ButtonDropdown.Option>
    <ButtonDropdown.Option
      className="backgroundExportButton"
      onClick={exportBookingsCsvInBackground}
      disabled={exportingBookingsCsv}>
      Background bookings CSV export (with financial data)
    </ButtonDropdown.Option>
  </ButtonDropdown>
);

class Paginator extends React.Component<any> {
  render() {
    const {
      exportBookingsCsvInBackground,
      exportBookingsWithoutFinancialDataCsvInBackground,
      exportContactsCsvInBackground,
      exportingBookingsCsv,
      exportingContactsCsv,
      disableExporting
    } = this.props;

    return (
      <PaginatorComponent
        pagination={this.props.pagination}
        onPageChange={this.props.onPageChange}
        ActionsComponent={() => (
          <Actions
            exportBookingsCsvInBackground={exportBookingsCsvInBackground}
            exportBookingsWithoutFinancialDataCsvInBackground={
              exportBookingsWithoutFinancialDataCsvInBackground
            }
            exportContactsCsvInBackground={exportContactsCsvInBackground}
            exportingBookingsCsv={exportingBookingsCsv}
            exportingContactsCsv={exportingContactsCsv}
            disableExporting={disableExporting}
          />
        )}
      />
    );
  }
}
export default Paginator;
